import { z } from 'zod';
import { apiGet, apiPost, demoMode } from './api';
import { demoMyBookings, demoRescheduleBooking, demoUpdateBookingStatus } from './demo';
import type { Slot } from './booking';

// Записи конкретного клиента для экрана «Профиль».
// Демо: всё, что создано в этой сессии вкладки (localStorage).
// Прод: сервер отдаёт только записи этого клиента по httpOnly-cookie mnc_client.
export const MyBookingSchema = z.object({
  id: z.string(),
  service_id: z.string(),
  staff_id: z.string(),
  resource_id: z.string(),
  starts_at: z.string(),
  ends_at: z.string(),
  client_name: z.string(),
  client_phone: z.string(),
  service_name: z.string(),
  price: z.number(),
  staff_name: z.string().nullable().optional(),
  status: z.enum(['pending', 'confirmed', 'cancelled', 'done'])
});

export type MyBooking = z.infer<typeof MyBookingSchema>;

export async function fetchMyBookings(_tenantId: string): Promise<MyBooking[]> {
  if (demoMode) {
    return z.array(MyBookingSchema).parse(demoMyBookings());
  }

  const data = await apiGet<unknown>('/my-bookings');
  return z.array(MyBookingSchema).parse(data);
}

export async function cancelMyBooking(id: string): Promise<void> {
  if (demoMode) return demoUpdateBookingStatus(id, 'cancelled');
  await apiPost<{ ok: boolean }>('/my-bookings/cancel', { id });
}

export async function rescheduleMyBooking(id: string, slot: Slot): Promise<void> {
  if (demoMode) return demoRescheduleBooking(id, slot);
  await apiPost<{ ok: boolean }>('/my-bookings/reschedule', {
    id,
    staffId: slot.staffId,
    resourceId: slot.resourceId,
    startsAt: slot.startsAt,
    endsAt: slot.endsAt
  });
}
